import {
  ConfigType,
} from './ConfigType';

export const HSG_CONFIG: ConfigType = {
  htmlFileOverride: 'src/userWeb/index.hsg.ejs',
  hlsServers: [
    'https://server1.hsg.ssnetworks.kr:4431',
    'https://server2.hsg.ssnetworks.kr:4432',

    'https://entrancedemo.hsg.test3.ssnetworks.kr',
    'https://server3.hsg.ssnetworks.kr:4433',
  ],
};

export default function getHSGConfig() {
  return HSG_CONFIG;
}
